(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function settleTransform(el) {
    var handled = false;
    function onEnd(e) {
      if (e && e.propertyName && e.propertyName !== 'transform') return;
      if (handled) return;
      handled = true;
      el.classList.add('fade-done');
      el.removeEventListener('transitionend', onEnd);
    }
    el.addEventListener('transitionend', onEnd);
    setTimeout(function () { onEnd({}); }, 1200);
  }

  function initFade() {
    var scopes = [];
    var main = document.getElementById('MainContent');
    if (main) scopes.push(main);
    var extra = document.querySelectorAll('[data-fade-scope]');
    for (var i = 0; i < extra.length; i++) scopes.push(extra[i]);

    var targets = [];
    scopes.forEach(function (scope) {
      var found = scope.querySelectorAll('.shopify-section, [data-fade-block]');
      for (var j = 0; j < found.length; j++) {
        if (targets.indexOf(found[j]) === -1) targets.push(found[j]);
      }
    });

    if (!targets.length) return;

    if (reduceMotion || typeof IntersectionObserver === 'undefined') {
      targets.forEach(function (el) { el.classList.add('lg-fade-in', 'is-visible', 'fade-done'); });
      return;
    }

    targets.forEach(function (el) { el.classList.add('lg-fade-in'); });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          settleTransform(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -10% 0px' });

    targets.forEach(function (el) { observer.observe(el); });

    window.addEventListener('load', function () {
      setTimeout(function () {
        document.querySelectorAll('.lg-fade-in:not(.is-visible)').forEach(function (el) {
          el.classList.add('is-visible');
          settleTransform(el);
        });
      }, 4000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFade);
  } else {
    initFade();
  }
})();
